import * as yup from 'yup';
import { text } from './text';
yup.setLocale({
    mixed: {
        required: text.COMMON.MIXED.REQUIRED.no,
        notType: text.COMMON.MIXED.NOT_TYPE.no,
    },
    number: {
        integer: text.COMMON.NUMBER.INTEGER.no,
        min: text.COMMON.NUMBER.MIN.no,
        max: text.COMMON.NUMBER.MAX.no,
    },
});
